import { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import GeneralAlert from 'in-meeting-experience-ui-components/components/common/GeneralAlert';
import { ErrorContext } from 'in-meeting-experience-ui-components/contexts/error/context';
import { useSelector } from 'react-redux';
import { routes } from '../../constants/routes';
import AccountsPage from '../../containers/AccountsPage';
import HomePage from '../../containers/HomePage';
import OauthRedirect from '../../containers/OauthRedirect';
import useGoogleSdkParams from '../../hooks/useGoogleSdkParams';
import useSidePanelClient from '../../hooks/useSidePanelClient';
import { clientSelector } from '../../slices/google/selectors';
import ApiOutageWrapper from '../errors/ApiOutageWrapper';
import UserRoutes from './UserRoutes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Routes = () => {
  const sdkClient = useSelector(clientSelector);
  const {
    isExternalOutage
  } = useContext(ErrorContext);
  useGoogleSdkParams();
  useSidePanelClient();
  if (!sdkClient && !isExternalOutage) return /*#__PURE__*/_jsx(LoadingOverlay, {});
  return /*#__PURE__*/_jsxs(ApiOutageWrapper, {
    children: [/*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: routes.home,
        exact: true,
        component: HomePage
      }), /*#__PURE__*/_jsx(Route, {
        path: routes.reconnect,
        exact: true,
        component: OauthRedirect
      }), /*#__PURE__*/_jsx(Route, {
        path: routes.accounts,
        exact: true,
        component: AccountsPage
      }), /*#__PURE__*/_jsx(Route, {
        path: routes.portalId,
        component: UserRoutes
      })]
    }), /*#__PURE__*/_jsx(GeneralAlert, {})]
  });
};